import React from 'react';
import { useMediaQueryContext } from '@fourthwall/components';
import * as S from './styled';
export const GroupTitle = ({ title }) => {
    const media = useMediaQueryContext();
    return media.tablet ? React.createElement(S.Title, null,
        title,
        ":") : React.createElement(S.Title, null, title);
};
